import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b8ff5d2c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b8ff5d2c&prod&scoped=true&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=b8ff5d2c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ff5d2c",
  null
  
)

export default component.exports